import { ActivatedRoute, Router } from "@angular/router";
import { LeadsService } from "./../../services/lead-service/lead-service.service";
import { Component, OnInit } from "@angular/core";
import { printAccountStatement } from "./accountStatementPrint";
import { print_template } from "../../shared/helpers/print_helpers";

@Component({
  selector: "app-account-statement-view",
  templateUrl: "./account-statement-view.component.html",
  styleUrls: ["./account-statement-view.component.css"],
})
export class AccountStatementViewComponent implements OnInit {
  id;

  balance;
  totalBalace = 0;
  payments;

  lead;

  unit_id = null;

  get leadPhones() {
    return [
      this.lead.phone,
      this.lead.phone_2,
      this.lead.phone_3,
      this.lead.phone_4,
      this.lead.phone_5,
      this.lead.phone_6,
    ]
      .filter((a) => a)
      .join(", ");
  }

  constructor(
    public leadsService: LeadsService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.id = this.route.snapshot.params.id;
    if (!this.id) {
      this.router.navigate([".."]);
    }
    this.getLead();
  }

  getLead() {
    this.leadsService.getLeadDetails(this.id).subscribe((res: any) => {
      this.lead = res.lead;
    });
  }

  getAccountStatements(is_export = false, unit_id = null) {
    // if (unit_id === this.unit_id) {
    //   this.unit_id = null;
    // } else {
    //   this.unit_id = unit_id;
    // }
    if (unit_id) this.unit_id = unit_id;
    else this.unit_id = null;
    this.leadsService
      .getAccountStatement(this.id, { is_export, unit_id: this.unit_id })
      .subscribe((res: any) => {
        if (is_export) {
          window.open(res.url, "_blank");
        } else {
          this.balance = res.balance;

          let currentBalance = 0;
          this.payments = res.payments.map((payment) => {
            if (payment.debit) {
              payment.balance = currentBalance += +payment.debit;
            }
            if (payment.credit) {
              payment.balance = currentBalance -= +payment.credit;
            }

            return payment;
          });

          this.totalBalace = currentBalance;
        }
      });
  }

  // helpers
  printStatement() {
    print_template(
      printAccountStatement,
      this.lead,
      this.payments,
      this.totalBalace
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/financial/account-statement-view/account-statement-view.component.ts